import React from "react";

import {useOtherAssetsData} from "../../CustomerDashboardV2/hooks/useOtherAssetsData";
import useOtherAssetsLocalSyncOnUnmount from "./useOtherAssetsLocalSync";

const useDepotsAndCashData = (customerId, cancelOnUnmount) => {
  const [depotsAndCashData, fetch, updateSharedData] = useOtherAssetsData(customerId, [], undefined, undefined, false, false, true, true, undefined, undefined, cancelOnUnmount);

  const [data, setData] = React.useState(depotsAndCashData);

  React.useEffect(() => {
    if(!depotsAndCashData.loading){
      setData(depotsAndCashData)
    }
  }, [depotsAndCashData.updatedAt]);

  const removeDepot = React.useCallback((groupId, ptf) => {
    setData(prevState => {
      const portfoliosData = {...prevState.data.portfolios};
      const assets = portfoliosData[groupId].assets.filter(a => a.id !== ptf.id);

      if(assets.length === 0){
        delete portfoliosData[groupId];
      } else {
        portfoliosData[groupId] = {assets: assets}
      }

      return {
        ...prevState,
        data: {
          ...prevState.data,
          portfolios: portfoliosData
        },
        updatedAt: +new Date()
      }
    })
  }, []);

  useOtherAssetsLocalSyncOnUnmount(depotsAndCashData, data, updateSharedData);

  return [data, fetch, removeDepot]
}

export default useDepotsAndCashData;